<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.product-costing-bom-report.edit.options'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-tax-inclusive-report-criteria></wbo-tax-inclusive-report-criteria>
                    </fui-column>
                    <fui-column>
                        <wbo-price-level-single-select-edit-control formControlName="priceLevel" [(ngModel)]="model.data.priceLevel" [allowClearSelectionOption]="false"></wbo-price-level-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <wbo-sellable-report-selection></wbo-sellable-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
